exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Examples{padding-top:60px;padding-bottom:60px;background-color:#e5f6fd}.Examples__title{font-weight:700;font-size:2.8rem;font-family:Oswald,serif;letter-spacing:.1rem;text-align:center;margin-bottom:30px}@media screen and (max-width:767px){.Examples__title{margin-bottom:20px}}.Examples a:active,.Examples a:hover,.Examples a:link,.Examples a:visited{color:#2d5da5}.Examples ul{padding-left:20px;list-style:outside none}.Examples ul li{position:relative;padding-left:17px}.Examples ul li:before{display:block;position:absolute;content:\"\";left:0;top:0.5em;width:7px;height:7px;background:#3160a1;border-radius:50%}@media screen and (max-width:767px){.Examples{padding-top:40px;padding-bottom:40px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../src/components/examples/index.scss
// module id = 862
// module chunks = 0